import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function StickyCTA({ onCTAClick }) {
  return (
    <div className="sticky-cta md:hidden" data-testid="sticky-cta">
      <div className="flex gap-3">
        <Button
          onClick={onCTAClick}
          className="flex-1 bg-[#b91c1c] hover:bg-[#991b1b] text-white h-12 rounded-full font-semibold shadow-lg"
          data-testid="sticky-cta-offert"
        >
          Få kostnadsfri offert
        </Button>
        <a href="tel:08-254604">
          <Button
            variant="outline"
            className="h-12 w-12 rounded-full border-2 border-slate-900 p-0"
            data-testid="sticky-cta-phone"
          >
            <Phone className="w-5 h-5" />
          </Button>
        </a>
      </div>
    </div>
  );
}
